<template><div></div></template>
<script>
	export default {
		name : 'logout',
		mounted(){
			this.emitter.emit('logout');
		}
	}
</script>